import React, { useEffect, useState } from 'react';

const Header = (props) => {
    const { occupation, email, resumedownload, address: { city }, social } = props.data;
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const networks = social.map(network => (
        <li key={network.name}>
            <a href={network.url}>
                <i className={network.className}></i>
            </a>
        </li>
    ));

    return (
        <div id="home">
            <div className="header-image"></div>
            <header>
                <div className="row banner">
                    <div className={`banner-text${visible ? ' visible' : ''}`}>
                        <h1 className="responsive-headline">
                            I'm <span className="my-name">Enrique Villa</span>.
                        </h1>
                        <h3 className="header-description">
                            <span>{city}</span>-based <span>{occupation}</span>.
                        </h3>
                        <hr />
                        <ul className="social">
                            {networks}
                        </ul>
                        <div className="contact-info">
                            <a href={`mailto:${email}`} className="contact-link">
                                <i className="fa fa-envelope"></i> {email}
                            </a>
                            <a href={resumedownload} className="contact-link" target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-download"></i> Resume
                            </a>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header.js